<template>
  <WdsText class="tw-truncate">{{ tenure }}</WdsText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $tc } from '@/composables/translation'

const HireTenureColumn = graphql(`
  fragment HireTenureColumn on Hire {
    id
    tenure
  }
`)

const props = defineProps<{ row: FragmentType<typeof HireTenureColumn> }>()
const column = computed(() => useFragment(HireTenureColumn, props.row))

const tenure = computed(() =>
  column.value.tenure === 0 ? '-' : $tc(':count day | :count days', column.value.tenure),
)
</script>
